import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDebounce } from 'use-debounce';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Services from './Services';
import Header from './Header';
import Loader from '../../../../../../../../components/Loaders/Loader';

import * as importTypes from '../../reducer/constants';
import { serviceServicesGetSyncRate } from '../../../../../../../../services/endpoints/services';
import { getErrorMessage } from '../../../../../helpers/getters';

const Step2 = (props) => {
  const initStep2 = useRef(true);

  const { success, error, dispatchImportState, isLoading, isLoadingRate, listSelected, providerId, options, onSubmit } = props;
  const { auto_rate_fixed, auto_rate_percent } = options;

  const [autoRateFixedDebounce] = useDebounce(auto_rate_fixed, 500);
  const [autoRatePercentDebounce] = useDebounce(auto_rate_percent, 500);

  const [stackRequest, setStackRequest] = useState([]);

  const getRate = async () => {
    try {
      const rates = listSelected.reduce((rates, category) => {
        if (category.services) {
          category.services.forEach((service) => {
            rates.push({
              provider_service_id: service.id,
              fixed: auto_rate_fixed,
              percent: auto_rate_percent,
            });
          });
        }
        return rates;
      }, []);

      const response = await serviceServicesGetSyncRate(providerId, rates);
      if (response?.data) {
        const { data } = response;
        if (_.isArray(data)) {
          setStackRequest((prevState) => prevState.filter((item, index) => index !== 0));
          dispatchImportState({ type: importTypes.IMPORT_CHANGE_RATE_SYNC, list: data });
        }
      }
    } catch (error) {
      setStackRequest((prevState) => prevState.filter((item, index) => index !== 0));
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
    }
  };

  const onBack = () => {
    dispatchImportState({ type: importTypes.IMPORT_STEP_1 });
  };

  useEffect(() => {
    if (stackRequest.length) {
      getRate();
    } else {
      dispatchImportState({ type: importTypes.IMPORT_CHANGE_RATE_SYNC_SUCCESS });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stackRequest]);

  useEffect(() => {
    if (initStep2.current) {
      initStep2.current = false;
    } else {
      setStackRequest((prevState) => [...prevState, true]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRateFixedDebounce, autoRatePercentDebounce]);

  useEffect(() => {
    if (auto_rate_fixed === autoRateFixedDebounce && isLoadingRate) {
      dispatchImportState({ type: importTypes.IMPORT_CHANGE_RATE_LOADING, value: false });
    }
  }, [autoRateFixedDebounce, auto_rate_fixed, dispatchImportState, isLoadingRate]);

  useEffect(() => {
    if (auto_rate_percent === autoRatePercentDebounce && isLoadingRate) {
      dispatchImportState({ type: importTypes.IMPORT_CHANGE_RATE_LOADING, value: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auto_rate_percent]);

  return (
    <div className="services-import__step">
      <Header {...props} dispatchImportState={dispatchImportState} />
      <Modal.Body>
        {isLoading ? <Loader success={success} /> : null}
        {error ? <div className="alert alert-danger">{error}</div> : null}
        <Services {...props} isLoadingRate={isLoadingRate || stackRequest.length} dispatchImportState={dispatchImportState} />
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer services-import__footer">
        <Button disabled={isLoading} onClick={onBack}>
          Back
        </Button>
        <Button bsStyle="primary" className="services-import__footer-next" disabled={isLoading} onClick={onSubmit}>
          Import services
        </Button>
      </Modal.Footer>
    </div>
  );
};

Step2.propTypes = {
  success: PropTypes.any,
  error: PropTypes.any,
  dispatchImportState: PropTypes.func,
  isLoading: PropTypes.bool,
  isLoadingRate: PropTypes.bool,
  listSelected: PropTypes.any,
  providerId: PropTypes.any,
  options: PropTypes.any,
  onSubmit: PropTypes.func,
};

export default Step2;
